export class PageNotFoundModel {
setValue(res){
if(res){
}
}
}